__turbopack_context__.v({
  "root": "Signup-module-scss-module__tC5maa__root",
});
